import { blueGrey } from "@mui/material/colors";

export const COLORS = Object.freeze({
  blue: {
    50: "#F0F7FF",
    100: "#C2E0FF",
    200: "#80BFFF",
    300: "#66B2FF",
    400: "#3399FF",
    500: "#007FFF",
    600: "#0072E5",
    700: "#0059B2",
    800: "#004C99",
    900: "#003A75",
  },

  grey: {
    50: "#f6f8fa",
    100: "#eaeef2",
    200: "#d0d7de",
    300: "#afb8c1",
    400: "#8c959f",
    500: "#6e7781",
    600: "#57606a",
    700: "#424a53",
    800: "#32383f",
    900: "#24292f",
  },
});

export const THEME = Object.freeze({
  bg: "#121212",
  border: blueGrey[700],
});

export const Colors = Object.freeze({
  orange: {
    default: "#FF7A00",
    hover: "#FDB220",
    active: "#E67C00",
  },
});
